import { api } from './client';
import type { ServicePreset } from '@/types/domain';

export async function fetchMyPresets(): Promise<{ results: ServicePreset[] }> {
  return api.get('/presets/me/');
}

export interface PresetInput {
  category_slug: string;
  title: string;
  description: string;
  price_eur: number;
  duration_minutes?: number;
  /** F-170 B3.3: "від {price} €" badge on the price (B0.4b). */
  price_is_from?: boolean;
  /** F-170 B3.2: where the service happens (B0.4). Drives the chip on
   *  ServiceCard and the location filter on SearchPage. */
  location_kind?: 'online' | 'delivery' | 'onsite';
}

export async function createPreset(input: PresetInput): Promise<ServicePreset> {
  return api.post('/presets/me/', { body: input });
}

export async function updatePreset(
  id: number,
  input: Partial<PresetInput> & { is_active?: boolean },
): Promise<ServicePreset> {
  return api.patch(`/presets/me/${id}/`, { body: input });
}

export async function deletePreset(id: number): Promise<void> {
  await api.del(`/presets/me/${id}/`);
}
